import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/icon/amway-cc-logo-b.svg'
import _imports_1 from '@/assets/icon/icon-team.svg'
import _imports_2 from '@/assets/icon/icon-reward.svg'
import _imports_3 from '@/assets/icon/icon-register-w.svg'
import _imports_4 from '@/assets/icon/icon-people.svg'
import _imports_5 from '@/assets/icon/icon-back-to.svg'
import _imports_6 from '@/assets/icon/amway-cc-logo-m.svg'
import _imports_7 from '@/assets/images/board/cloud-l.svg'
import _imports_8 from '@/assets/images/board/spotlight.svg'
import _imports_9 from '@/assets/images/board/cloud-r.svg'
import _imports_10 from '@/assets/images/board/firework.svg'
import _imports_11 from '@/assets/images/board/final-1-10.svg'
import _imports_12 from '@/assets/images/board/final-1-10-m.svg'
import _imports_13 from '@/assets/images/board/medal.svg'
import _imports_14 from '@/assets/images/board/final-11-70.svg'
import _imports_15 from '@/assets/images/board/final-11-70-m.svg'
import _imports_16 from '@/assets/images/board/ribbon-l.svg'
import _imports_17 from '@/assets/images/board/ribbon-r.svg'
import _imports_18 from '@/assets/images/board/ribbon-m.svg'
import _imports_19 from '@/assets/icon/amway-logo.svg'
import _imports_20 from '@/assets/icon/icon-phone.svg'


const _hoisted_1 = { class: "leader-board" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "header-area desktop" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Amway Creator Challenge"
}, null, -1)
const _hoisted_5 = { class: "header-right" }
const _hoisted_6 = { class: "header-menu" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode("คะแนนทีมของคุณ")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode("ผลการแข่งขันรายสัปดาห์")
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode("ประกาศผลรางวัลชนะเลิศ")
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }),
  /*#__PURE__*/_createTextVNode("รายละเอียดกิจกรรม")
], -1)
const _hoisted_14 = { class: "profile-area" }
const _hoisted_15 = ["src"]
const _hoisted_16 = {
  class: "profile-info",
  id: "profile-info"
}
const _hoisted_17 = { class: "profile-info-area" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1)
const _hoisted_19 = { class: "profile-info-name" }
const _hoisted_20 = { class: "profile-info-id" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.amway.co.th",
  target: "_blank",
  class: "link-red"
}, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_5 }),
  /*#__PURE__*/_createTextVNode("กลับไปยังเว็บไซต์หลัก ")
], -1)
const _hoisted_22 = { class: "header-area mobile" }
const _hoisted_23 = { class: "header-logo-area" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: "Amway Creator Challenge"
}, null, -1)
const _hoisted_25 = {
  class: "profile-area",
  id: "profile-area-m"
}
const _hoisted_26 = ["src"]
const _hoisted_27 = {
  class: "profile-info",
  id: "profile-info-m"
}
const _hoisted_28 = { class: "profile-info-area" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1)
const _hoisted_30 = { class: "profile-info-name" }
const _hoisted_31 = { class: "profile-info-id" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.amway.co.th",
  class: "link-red"
}, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_5 }),
  /*#__PURE__*/_createTextVNode("กลับไปยังเว็บไซต์หลัก ")
], -1)
const _hoisted_33 = {
  class: "sub-menu",
  id: "sub-menu"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_35 = /*#__PURE__*/_createTextVNode("คะแนนทีมของคุณ ")
const _hoisted_36 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_37 = /*#__PURE__*/_createTextVNode("ผลการแข่งขันรายสัปดาห์ ")
const _hoisted_38 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_39 = /*#__PURE__*/_createTextVNode("ประกาศผลรางวัลชนะเลิศ ")
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }),
  /*#__PURE__*/_createTextVNode("รายละเอียดกิจกรรม ")
], -1)
const _hoisted_41 = { class: "final-result-content" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  class: "cloud-l"
}, null, -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  class: "green-spotlight"
}, null, -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  class: "cloud-r"
}, null, -1)
const _hoisted_45 = { class: "container" }
const _hoisted_46 = /*#__PURE__*/_createStaticVNode("<div class=\"title-area\"><div class=\"title-final\"><div class=\"title-final-g\">ประกาศรายชื่อทีมที่ได้รับ</div><div class=\"title-final-r\">รางวัลชนะเลิศ</div><img src=\"" + _imports_10 + "\" class=\"title-firework\"></div></div><div class=\"reward-detail\"><img src=\"" + _imports_11 + "\" class=\"desktop\"><img src=\"" + _imports_12 + "\" class=\"mobile\"><div class=\"rd-text\">รับทริปท่องเที่ยวทริปญี่ปุ่น เกียวโต โอซาก้า <br class=\"mobile\">พร้อมกับกูรูด้านการถ่ายภาพ <br class=\"mobile\">สร้างคอนเทนต์แบบครีเอเตอร์โปร</div><div class=\"rd-green\">มูลค่า 350,000 บาท/ทีม</div></div>", 2)
const _hoisted_48 = { class: "table-d" }
const _hoisted_49 = { class: "rank-table" }
const _hoisted_50 = /*#__PURE__*/_createStaticVNode("<div class=\"rt-head\"><div class=\"rth-row\"><img src=\"" + _imports_13 + "\" class=\"rt-medal\"><div class=\"rt-title\">อันดับที่ 1-10</div></div><div class=\"rth-row\"><div class=\"rth-col\">สมาชิกที่<br>เป็นนธอ.ใหม่</div><div class=\"rth-col\">การเข้าเรียน</div><div class=\"rth-col\">การโพสต์<br>คอนเทนต์</div><div class=\"rth-col\">การสปอนเซอร์</div><div class=\"rth-col\">เข้ากลุ่ม Facebook</div><div class=\"rth-col\">ชุดเริ่มควบคุมน้ำหนักบอดี้คีย์</div><div class=\"rth-col\">คะแนนรวม</div></div></div>", 1)
const _hoisted_51 = { class: "rt-content" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "rt-col" }, null, -1)
const _hoisted_53 = { class: "rt-col" }
const _hoisted_54 = { class: "rt-col" }
const _hoisted_55 = { class: "rt-col" }
const _hoisted_56 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_57 = { class: "rt-col" }
const _hoisted_58 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_59 = { class: "rt-col" }
const _hoisted_60 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_61 = { class: "rt-col" }
const _hoisted_62 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_63 = { class: "rt-col" }
const _hoisted_64 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_65 = { class: "rt-col" }
const _hoisted_66 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_67 = { class: "rt-col" }
const _hoisted_68 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_69 = { class: "table-m" }
const _hoisted_70 = { class: "rank-table" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", { class: "rt-head" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_13,
    class: "rt-medal"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "rt-title" }, "อันดับที่ 1-10")
], -1)
const _hoisted_72 = { class: "rt-content" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("div", { class: "rt-col" }, null, -1)
const _hoisted_74 = { class: "rt-col" }
const _hoisted_75 = { class: "rt-col" }
const _hoisted_76 = { class: "rt-col" }
const _hoisted_77 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_78 = /*#__PURE__*/_createElementVNode("div", { class: "rt-col" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "btn-expand" })
], -1)
const _hoisted_79 = { class: "rt-content-body" }
const _hoisted_80 = { class: "rt-cb-row" }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("div", { class: "rt-cb-title" }, "การเข้าเรียน", -1)
const _hoisted_82 = { class: "rt-cb-text" }
const _hoisted_83 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_84 = { class: "rt-cb-row" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("div", { class: "rt-cb-title" }, "การโพสต์คอนเทนต์", -1)
const _hoisted_86 = { class: "rt-cb-text" }
const _hoisted_87 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_88 = { class: "rt-cb-row" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("div", { class: "rt-cb-title" }, "การสปอนเซอร์", -1)
const _hoisted_90 = { class: "rt-cb-text" }
const _hoisted_91 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_92 = { class: "rt-cb-row" }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("div", { class: "rt-cb-title" }, "สมาชิกที่เป็นนธอ.ใหม่", -1)
const _hoisted_94 = { class: "rt-cb-text" }
const _hoisted_95 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_96 = { class: "rt-cb-row" }
const _hoisted_97 = /*#__PURE__*/_createElementVNode("div", { class: "rt-cb-title" }, "เข้ากลุ่ม Facebook", -1)
const _hoisted_98 = { class: "rt-cb-text" }
const _hoisted_99 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_100 = { class: "rt-cb-row" }
const _hoisted_101 = /*#__PURE__*/_createElementVNode("div", { class: "rt-cb-title" }, "ชุดเริ่มควบคุมน้ำหนักบอดี้คีย์", -1)
const _hoisted_102 = { class: "rt-cb-text" }
const _hoisted_103 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_104 = /*#__PURE__*/_createStaticVNode("<div class=\"title-sub-final\"><div class=\"title-sub-final-g\">ประกาศรายชื่อทีมที่ได้รับ</div><div class=\"title-sub-final-r\">รางวัลชมเชย</div><img src=\"" + _imports_10 + "\" class=\"title-firework\"></div><div class=\"reward-detail\"><img src=\"" + _imports_14 + "\" class=\"desktop\"><img src=\"" + _imports_15 + "\" class=\"mobile\"><div class=\"rd-text\">รับกิ๊ฟท์เซตกล้องโพลารอยด์<br class=\"mobile\">ครีเอเตอร์สุดเก๋ท่านละ 1 ชุด</div><div class=\"rd-green\">มูลค่า 1,600 บาท/รางวัล รวม 60 รางวัล</div><img src=\"" + _imports_16 + "\" class=\"ribbon-l desktop\"><img src=\"" + _imports_17 + "\" class=\"ribbon-r desktop\"><img src=\"" + _imports_18 + "\" class=\"ribbon-m mobile\"></div>", 2)
const _hoisted_106 = { class: "table-d" }
const _hoisted_107 = { class: "rank-table" }
const _hoisted_108 = /*#__PURE__*/_createStaticVNode("<div class=\"rt-head\"><div class=\"rth-row\"><img src=\"" + _imports_13 + "\" class=\"rt-medal\"><div class=\"rt-title\">อันดับที่ 11-70</div></div><div class=\"rth-row\"><div class=\"rth-col\">สมาชิกที่เป็นนธอ.ใหม่</div><div class=\"rth-col\">การเข้าเรียน</div><div class=\"rth-col\">การโพสต์คอนเทนต์</div><div class=\"rth-col\">การสปอนเซอร์</div><div class=\"rth-col\">เข้ากลุ่ม Facebook</div><div class=\"rth-col\">ชุดเริ่มควบคุมน้ำหนักบอดี้คีย์</div><div class=\"rth-col\">คะแนนรวม</div></div></div>", 1)
const _hoisted_109 = { class: "rt-content" }
const _hoisted_110 = /*#__PURE__*/_createElementVNode("div", { class: "rt-col" }, null, -1)
const _hoisted_111 = { class: "rt-col" }
const _hoisted_112 = { class: "rt-col" }
const _hoisted_113 = { class: "rt-col" }
const _hoisted_114 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_115 = { class: "rt-col" }
const _hoisted_116 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_117 = { class: "rt-col" }
const _hoisted_118 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_119 = { class: "rt-col" }
const _hoisted_120 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_121 = { class: "rt-col" }
const _hoisted_122 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_123 = { class: "rt-col" }
const _hoisted_124 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_125 = { class: "rt-col" }
const _hoisted_126 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_127 = { class: "table-m" }
const _hoisted_128 = { class: "rank-table" }
const _hoisted_129 = /*#__PURE__*/_createElementVNode("div", { class: "rt-head" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_13,
    class: "rt-medal"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "rt-title" }, "อันดับที่ 11-70")
], -1)
const _hoisted_130 = { class: "rt-content" }
const _hoisted_131 = /*#__PURE__*/_createElementVNode("div", { class: "rt-col" }, null, -1)
const _hoisted_132 = { class: "rt-col" }
const _hoisted_133 = { class: "rt-col" }
const _hoisted_134 = { class: "rt-col" }
const _hoisted_135 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_136 = /*#__PURE__*/_createElementVNode("div", { class: "rt-col" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "btn-expand" })
], -1)
const _hoisted_137 = { class: "rt-content-body" }
const _hoisted_138 = { class: "rt-cb-row" }
const _hoisted_139 = /*#__PURE__*/_createElementVNode("div", { class: "rt-cb-title" }, "การเข้าเรียน", -1)
const _hoisted_140 = { class: "rt-cb-text" }
const _hoisted_141 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_142 = { class: "rt-cb-row" }
const _hoisted_143 = /*#__PURE__*/_createElementVNode("div", { class: "rt-cb-title" }, "การโพสต์คอนเทนต์", -1)
const _hoisted_144 = { class: "rt-cb-text" }
const _hoisted_145 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_146 = { class: "rt-cb-row" }
const _hoisted_147 = /*#__PURE__*/_createElementVNode("div", { class: "rt-cb-title" }, "การสปอนเซอร์", -1)
const _hoisted_148 = { class: "rt-cb-text" }
const _hoisted_149 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_150 = { class: "rt-cb-row" }
const _hoisted_151 = /*#__PURE__*/_createElementVNode("div", { class: "rt-cb-title" }, "สมาชิกที่เป็นนธอ.ใหม่", -1)
const _hoisted_152 = { class: "rt-cb-text" }
const _hoisted_153 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_154 = { class: "rt-cb-row" }
const _hoisted_155 = /*#__PURE__*/_createElementVNode("div", { class: "rt-cb-title" }, "เข้ากลุ่ม Facebook", -1)
const _hoisted_156 = { class: "rt-cb-text" }
const _hoisted_157 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_158 = { class: "rt-cb-row" }
const _hoisted_159 = /*#__PURE__*/_createElementVNode("div", { class: "rt-cb-title" }, "ชุดเริ่มควบคุมน้ำหนักบอดี้คีย์", -1)
const _hoisted_160 = { class: "rt-cb-text" }
const _hoisted_161 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_162 = /*#__PURE__*/_createStaticVNode("<section class=\"footer\"><div class=\"container\"><div class=\"row mx-0\"><div class=\"footer-logo\"><img src=\"" + _imports_19 + "\" height=\"40px\"></div><div class=\"footer-address\">บริษัท แอมเวย์ (ประเทศไทย) จำกัด <br>1199/1 ถนนรามคำแหง แขวงหัวหมาก เขตบางกะปิ กรุงเทพ ฯ 10240</div><div class=\"footer-call\"><div class=\"footer-call-text\">ต้องการความช่วยเหลือ ?</div><div class=\"footer-call-phone\"><img src=\"" + _imports_20 + "\"><a href=\"tel:+0-2725-8000\">0-2725-8000</a></div></div><div class=\"copy-right\">Copyright 2022, Amway (Thailand) Ltd,.</div></div></div></section>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/final_result",
          class: "header-logo"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_router_link, { to: "final_score" }, {
              default: _withCtx(() => [
                _hoisted_7,
                _hoisted_8
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: "leader_board" }, {
              default: _withCtx(() => [
                _hoisted_9,
                _hoisted_10
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: "final_result" }, {
              default: _withCtx(() => [
                _hoisted_11,
                _hoisted_12
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/challenge",
              class: "btn-red",
              style: {"width":"184px"}
            }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", {
              class: "profile-icon",
              onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.showProfileInfo();})
            }, [
              _createElementVNode("img", {
                src: _ctx.$store.state.userInfo.profile_image ? _ctx.$store.state.userInfo.profile_image : require('@/assets/images/landing/people.svg')
              }, null, 8, _hoisted_15)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$store.state.userInfo.name), 1),
                  _createElementVNode("div", _hoisted_20, "รหัสนักธุรกิจแอมเวย์ " + _toDisplayString(_ctx.$store.state.userInfo.abo_id), 1)
                ])
              ]),
              _hoisted_21
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", {
            class: "ham",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openMenu(this)))
          }),
          _createVNode(_component_router_link, {
            to: "final_result",
            class: "header-logo"
          }, {
            default: _withCtx(() => [
              _hoisted_24
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", {
            class: "profile-icon",
            onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.showProfileInfo();})
          }, [
            _createElementVNode("img", {
              src: _ctx.$store.state.userInfo.profile_image ? _ctx.$store.state.userInfo.profile_image : require('@/assets/images/landing/people.svg')
            }, null, 8, _hoisted_26)
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _hoisted_29,
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.$store.state.userInfo.name), 1),
                _createElementVNode("div", _hoisted_31, "รหัสนักธุรกิจแอมเวย์ " + _toDisplayString(_ctx.$store.state.userInfo.abo_id), 1)
              ])
            ]),
            _hoisted_32
          ])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createVNode(_component_router_link, { to: "final_score" }, {
            default: _withCtx(() => [
              _hoisted_34,
              _hoisted_35
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "leader_board" }, {
            default: _withCtx(() => [
              _hoisted_36,
              _hoisted_37
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "final_result" }, {
            default: _withCtx(() => [
              _hoisted_38,
              _hoisted_39
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/challenge",
            class: "btn-red fixed",
            style: {"right":"16px","bottom":"0","width":"calc(100% - 32px)"},
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openMenu()))
          }, {
            default: _withCtx(() => [
              _hoisted_40
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_41, [
      _hoisted_42,
      _hoisted_43,
      _hoisted_44,
      _createElementVNode("div", _hoisted_45, [
        _hoisted_46,
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("div", _hoisted_49, [
            _hoisted_50,
            _createElementVNode("div", _hoisted_51, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ranks.slice(0, 10), (rank) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["rt-row", `rt-row ${rank.team_name ==  _ctx.team.team_name ? 'my-team' : ''}`]),
                  key: rank.rank
                }, [
                  _hoisted_52,
                  _createElementVNode("div", _hoisted_53, _toDisplayString(rank.rank) + ".", 1),
                  _createElementVNode("div", _hoisted_54, _toDisplayString(rank.team_name), 1),
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("span", null, _toDisplayString(rank.sum_team_score.new_member), 1),
                    _hoisted_56
                  ]),
                  _createElementVNode("div", _hoisted_57, [
                    _createElementVNode("span", null, _toDisplayString(rank.sum_team_score.online_class), 1),
                    _hoisted_58
                  ]),
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("span", null, _toDisplayString(rank.sum_team_score.social_posting), 1),
                    _hoisted_60
                  ]),
                  _createElementVNode("div", _hoisted_61, [
                    _createElementVNode("span", null, _toDisplayString(rank.sum_team_score.sponsoring), 1),
                    _hoisted_62
                  ]),
                  _createElementVNode("div", _hoisted_63, [
                    _createElementVNode("span", null, _toDisplayString(rank.sum_team_score.social_join), 1),
                    _hoisted_64
                  ]),
                  _createElementVNode("div", _hoisted_65, [
                    _createElementVNode("span", null, _toDisplayString(rank.sum_team_score.body_key || 0), 1),
                    _hoisted_66
                  ]),
                  _createElementVNode("div", _hoisted_67, [
                    _createElementVNode("span", null, _toDisplayString(rank.sum_team_total_score), 1),
                    _hoisted_68
                  ])
                ], 2))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_69, [
          _createElementVNode("div", _hoisted_70, [
            _hoisted_71,
            _createElementVNode("div", _hoisted_72, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ranks.slice(0, 10), (rank) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["rt-row", `rt-row ${rank.team_name ==  _ctx.team.team_name ? 'my-team' : ''}`]),
                  key: rank.rank
                }, [
                  _createElementVNode("div", {
                    class: "rt-content-head",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showContent($event)))
                  }, [
                    _hoisted_73,
                    _createElementVNode("div", _hoisted_74, _toDisplayString(rank.rank) + ".", 1),
                    _createElementVNode("div", _hoisted_75, _toDisplayString(rank.team_name), 1),
                    _createElementVNode("div", _hoisted_76, [
                      _createElementVNode("span", null, _toDisplayString(rank.sum_team_total_score), 1),
                      _hoisted_77
                    ]),
                    _hoisted_78
                  ]),
                  _createElementVNode("div", _hoisted_79, [
                    _createElementVNode("div", _hoisted_80, [
                      _hoisted_81,
                      _createElementVNode("div", _hoisted_82, [
                        _createElementVNode("span", null, _toDisplayString(rank.sum_team_score.online_class), 1),
                        _hoisted_83
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_84, [
                      _hoisted_85,
                      _createElementVNode("div", _hoisted_86, [
                        _createElementVNode("span", null, _toDisplayString(rank.sum_team_score.social_posting), 1),
                        _hoisted_87
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_88, [
                      _hoisted_89,
                      _createElementVNode("div", _hoisted_90, [
                        _createElementVNode("span", null, _toDisplayString(rank.sum_team_score.sponsoring), 1),
                        _hoisted_91
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_92, [
                      _hoisted_93,
                      _createElementVNode("div", _hoisted_94, [
                        _createElementVNode("span", null, _toDisplayString(rank.sum_team_score.new_member), 1),
                        _hoisted_95
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_96, [
                      _hoisted_97,
                      _createElementVNode("div", _hoisted_98, [
                        _createElementVNode("span", null, _toDisplayString(rank.sum_team_score.social_join), 1),
                        _hoisted_99
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_100, [
                      _hoisted_101,
                      _createElementVNode("div", _hoisted_102, [
                        _createElementVNode("span", null, _toDisplayString(rank.sum_team_score.body_key || 0), 1),
                        _hoisted_103
                      ])
                    ])
                  ])
                ], 2))
              }), 128))
            ])
          ])
        ]),
        _hoisted_104,
        _createElementVNode("div", _hoisted_106, [
          _createElementVNode("div", _hoisted_107, [
            _hoisted_108,
            _createElementVNode("div", _hoisted_109, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ranks.slice(10, 70), (rank) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["rt-row", `rt-row ${rank.team_name ==  _ctx.team.team_name ? 'my-team' : ''}`]),
                  key: rank.rank
                }, [
                  _hoisted_110,
                  _createElementVNode("div", _hoisted_111, _toDisplayString(rank.rank) + ".", 1),
                  _createElementVNode("div", _hoisted_112, _toDisplayString(rank.team_name), 1),
                  _createElementVNode("div", _hoisted_113, [
                    _createElementVNode("span", null, _toDisplayString(rank.sum_team_score.new_member), 1),
                    _hoisted_114
                  ]),
                  _createElementVNode("div", _hoisted_115, [
                    _createElementVNode("span", null, _toDisplayString(rank.sum_team_score.online_class), 1),
                    _hoisted_116
                  ]),
                  _createElementVNode("div", _hoisted_117, [
                    _createElementVNode("span", null, _toDisplayString(rank.sum_team_score.social_posting), 1),
                    _hoisted_118
                  ]),
                  _createElementVNode("div", _hoisted_119, [
                    _createElementVNode("span", null, _toDisplayString(rank.sum_team_score.sponsoring), 1),
                    _hoisted_120
                  ]),
                  _createElementVNode("div", _hoisted_121, [
                    _createElementVNode("span", null, _toDisplayString(rank.sum_team_score.social_join), 1),
                    _hoisted_122
                  ]),
                  _createElementVNode("div", _hoisted_123, [
                    _createElementVNode("span", null, _toDisplayString(rank.sum_team_score.body_key), 1),
                    _hoisted_124
                  ]),
                  _createElementVNode("div", _hoisted_125, [
                    _createElementVNode("span", null, _toDisplayString(rank.sum_team_total_score), 1),
                    _hoisted_126
                  ])
                ], 2))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_127, [
          _createElementVNode("div", _hoisted_128, [
            _hoisted_129,
            _createElementVNode("div", _hoisted_130, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ranks.slice(10, 70), (rank) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["rt-row", `rt-row ${rank.team_name ==  _ctx.team.team_name ? 'my-team' : ''}`]),
                  key: rank.rank
                }, [
                  _createElementVNode("div", {
                    class: "rt-content-head",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showContent($event)))
                  }, [
                    _hoisted_131,
                    _createElementVNode("div", _hoisted_132, _toDisplayString(rank.rank) + ".", 1),
                    _createElementVNode("div", _hoisted_133, _toDisplayString(rank.team_name), 1),
                    _createElementVNode("div", _hoisted_134, [
                      _createElementVNode("span", null, _toDisplayString(rank.sum_team_total_score), 1),
                      _hoisted_135
                    ]),
                    _hoisted_136
                  ]),
                  _createElementVNode("div", _hoisted_137, [
                    _createElementVNode("div", _hoisted_138, [
                      _hoisted_139,
                      _createElementVNode("div", _hoisted_140, [
                        _createElementVNode("span", null, _toDisplayString(rank.sum_team_score.online_class), 1),
                        _hoisted_141
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_142, [
                      _hoisted_143,
                      _createElementVNode("div", _hoisted_144, [
                        _createElementVNode("span", null, _toDisplayString(rank.sum_team_score.social_posting), 1),
                        _hoisted_145
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_146, [
                      _hoisted_147,
                      _createElementVNode("div", _hoisted_148, [
                        _createElementVNode("span", null, _toDisplayString(rank.sum_team_score.sponsoring), 1),
                        _hoisted_149
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_150, [
                      _hoisted_151,
                      _createElementVNode("div", _hoisted_152, [
                        _createElementVNode("span", null, _toDisplayString(rank.sum_team_score.new_member), 1),
                        _hoisted_153
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_154, [
                      _hoisted_155,
                      _createElementVNode("div", _hoisted_156, [
                        _createElementVNode("span", null, _toDisplayString(rank.sum_team_score.social_join), 1),
                        _hoisted_157
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_158, [
                      _hoisted_159,
                      _createElementVNode("div", _hoisted_160, [
                        _createElementVNode("span", null, _toDisplayString(rank.sum_team_score.body_key), 1),
                        _hoisted_161
                      ])
                    ])
                  ])
                ], 2))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _hoisted_162
  ]))
}